<mat-drawer-container class="main-container" style="background-color: white;" autosize>
    <mat-drawer #drawer class="sidenav-drawer" class="drawer-style" mode="side" opened>
        <div class="mt-40">
        </div>
    </mat-drawer>
    <mat-drawer-content class="overflow-hidden">
        <div class="sidenav-content">

            <div class="row col-12 m-0 centerAlign">
                <div class="col-5 mt-5">
                    <div class="entityDet-title">
                        <form class="w-100" [formGroup]="resetPasswordForm" 
                        (ngSubmit)="resetPassword(resetPasswordForm.value)">
                            <h2 class="justify-content-center d-flex w-100 fontweighthead">Reset password</h2>
                            <div *ngIf="showError" class="alert alert-danger" role="alert">
                                {{errorMessage}}
                            </div>                    
                            <div *ngIf="showSuccess" class="alert alert-success" role="alert">
                                {{successMessage}}
                            </div>
                            <div class="col-md-12">                              
                                    <label for="password" class="fontweightlabel">Old password:</label>
                                    <input type="password" id="password" formControlName="password" class="form-control" autocomplete="off" />                                                               
                            </div>                           
                            <div class="col-md-5">
                                <em *ngIf="validateControl('password') && hasError('password', 'required')">password is
                                    required</em>
                            </div>  
                            <br>
                            <div class="button-row" >                               
                                    <button class="col-md-12 buttonstyle"
                                    [disabled]="!resetPasswordForm.valid"
                                     mat-raised-button >Submit</button>
                                    &nbsp;&nbsp;
                                     <button  class="col-md-12 buttonstyle"                                   
                                     mat-raised-button (click)="cancel()" >Cancel</button>
                            </div>
                        </form>
                    </div>

                </div>
                <div class="col-4  mt-5">
                    <!-- <img class="pl-3" src="/assets/images/SI4.png" alt="" style="width: 500px; height: 300px;"> -->
                    <img src="/assets/images/image.png" alt="" class="imgstyle pl-3">
                </div>
            </div>

        </div>
    </mat-drawer-content>
</mat-drawer-container>